export class ChatModel {
  constructor(
    public audio: any = "",
    public message: any = "",
    public options: any = [],
    public type: string = "text",
    public user: string = "homero",
    public show: boolean = true,
  ) {}
}
